import { Controller } from "stimulus";
import { submitForm } from "init/ajax";

export default class extends Controller {
  static targets = ['form']

  validate(e) {
    e.preventDefault()
    const requiredFields = this.formTarget.querySelectorAll("[required]");
    console.log(requiredFields)
    let valid = true;
    this.invalid_fields = [];
    requiredFields.forEach(field => {
      const parent = field.parentNode;
      const errors = parent.querySelectorAll(".error-msg");
      const error_msg = errors.length > 0 ? errors[errors.length - 1] : null;

      if (field.checkValidity()) {
        // Valid Field
        parent.classList.remove("error");
        if (error_msg) error_msg.remove();
      } else {
        // Invalid Field
        const child = error_msg ? error_msg : document.createElement("span");
        const msg = field.validationMessage;
        this.invalid_fields.push(field);
        if (!parent.querySelector(".error-msg")) {
          child.classList.add("error-msg");
          child.innerText = msg;
          parent.classList.add("error");
          parent.appendChild(child);
        } else {
          child.innerText = msg;
        }
        valid = false;
      }
    });
    if (valid) {
      this.formTarget.submit()
    } else {
      let field = this.invalid_fields[0]
      field.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    }
  }
}
